<script setup>

import { defineProps, defineEmits} from "vue";
import AprovadoresCartaoTabela from "./Aprovadores/AprovadoresTabela.vue";
import JustificativaCartao from "./Justificativa/JustificativaCartao.vue";
import FornecedorCartao from "./Fornecedor/FornecedorCartao.vue";
import ItensTabela from "./Itens/ItensTabela.vue";
import ParcelasTabela from "./Parcelas/ParcelasTabela.vue";
import ObservacoesGeraisCartao from "./ObservacoesGerais/ObservacoesGeraisCartao.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pedidoDeCompra",
    "justificativa",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:justificativa",
]);

//==================================================================//
//====================== Altera Justificativa ======================//
//==================================================================//

const alteraJustificativa = (update) =>{

    emits('update:justificativa',update);

};

</script>

<template>

    <div
        class="c-conteudo"
    >

        <AprovadoresCartaoTabela
            :pedidoDeCompra="props.pedidoDeCompra"
        >
        </AprovadoresCartaoTabela>

        <JustificativaCartao
            :justificativa="props?.justificativa"
            :controlesDesativados="props?.controlesDesativados"
            @update:justificativa="alteraJustificativa"
        ></JustificativaCartao>

        <FornecedorCartao
            :pedidoDeCompra="props.pedidoDeCompra"
        >
        </FornecedorCartao>

        <ItensTabela
            :pedidoDeCompra="props.pedidoDeCompra"
        >
        </ItensTabela>

        <ParcelasTabela
            :pedidoDeCompra="props.pedidoDeCompra"
        >
        </ParcelasTabela>

        <ObservacoesGeraisCartao
            :pedidoDeCompra="props.pedidoDeCompra"
        >
        </ObservacoesGeraisCartao>

    </div>

</template>

<style scoped>

.c-conteudo{
    display: grid;
    gap: 15px;
}

</style>